const menuItemStyles = {
  root: {
    minWidth: '300px !important',
    width: '300px !important',
    '&:hover': {
      color: '#ffffff !important',
      backgroundColor: '#2196F3 !important',
    },
    '&:active': {
      minWidth: '300px !important',
      width: '300px !important',
    },
  },
  selected: {
    minWidth: '300px !important',
    width: '300px !important',
    '&:hover': {
      color: '#ffffff !important',
      backgroundColor: '#2974FF !important',
    },
    backgroundColor: '#2974FF !important',
    color: '#ffffff !important',
  },
};

export default menuItemStyles;



// WEBPACK FOOTER //
// ./src/components/passengers/relationshipDropdown/MenuItemStyles.js